<script>
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { insertHistoryAction } from "@app/store/historyStore.svelte.js";
import { editorState } from "@app/store/editorStore.svelte.js";
import shiftWordForward from "@cclib/functions/quill/shiftWordForward.js";
import getAvgTimePerWord from "@cclib/functions/events/getAvgTimePerWord.js";
import * as m from '@app/paraglide/messages.js';

/* remove last word from event and add it to the beginning of the next event. */
function shiftWordToNextEvent() {
    try {
        if (!eventGroupState[projectState.selected]) return;
        if (eventGroupState[projectState.selected].selected.length === 0)
            return;
        if (
            eventGroupState[projectState.selected].selected[0] ===
            eventGroupState[projectState.selected].events.length - 1
        )
            return;

        eventGroupState[projectState.selected].selected = [
            eventGroupState[projectState.selected].selected[0],
        ];

        let res = shiftWordForward(
            eventGroupState[projectState.selected].events[
                eventGroupState[projectState.selected].selected[0]
            ],
            eventGroupState[projectState.selected].events[
                eventGroupState[projectState.selected].selected[0] + 1
            ],
            eventGroupState[projectState.selected].maxChars,
        );

        eventGroupState[projectState.selected].events[
            eventGroupState[projectState.selected].selected[0]
        ].text = res.event1.text;

        eventGroupState[projectState.selected].events[
            eventGroupState[projectState.selected].selected[0] + 1
        ].text = res.event2.text;

        if (window.quillEditor) {
            let eventIndex = eventGroupState[projectState.selected].selected[0];
            let delta = window.quillEditor.clipboard.convert({ html: eventGroupState[projectState.selected].events[eventIndex].text });
            window.quillEditor.setContents(delta, "silent");
            window.quillEditor.formatLine(0,9999, 'align', eventGroupState[projectState.selected].events[eventIndex].alignment === 'left' ? '' : eventGroupState[projectState.selected].events[eventIndex].alignment, "silent");
        }

        if (editorState.updateTimeOnEdit) {
            let currentEvent =
                eventGroupState[projectState.selected].events[
                    eventGroupState[projectState.selected].selected[0]
                ];
            let nextEvent =
                eventGroupState[projectState.selected].events[
                    eventGroupState[projectState.selected].selected[0] + 1
                ];

            if (
                currentEvent.start &&
                currentEvent.end &&
                nextEvent.start &&
                nextEvent.end
            ) {
                let avgTimePerWord = getAvgTimePerWord(currentEvent);

                if (avgTimePerWord > 0 && avgTimePerWord !== Infinity && !isNaN(avgTimePerWord)) {
                    eventGroupState[projectState.selected].events[
                        eventGroupState[projectState.selected].selected[0] + 1
                    ].start -= avgTimePerWord;
                    eventGroupState[projectState.selected].events[
                        eventGroupState[projectState.selected].selected[0]
                    ].end -= avgTimePerWord; 
                }
            }
        }

        insertHistoryAction({
            name: "shift word", //action name
            eventGroup: projectState.selected,
            snapshots: [
                {
                    store: "eventGroupState",
                    value: JSON.stringify(eventGroupState),
                },
            ],
        });
    } catch (err) {
        console.log(err, err.message);
    }
}
</script>

<li class="nav-item" title={m.shift_word_forward_title()}>
    <a
        id="shift-word-down-btn"
        class="nav-link"
        href="#!/"
        class:disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0 ||
            eventGroupState[projectState.selected].selected[0] ===
                eventGroupState[projectState.selected].events.length - 1}
        aria-disabled={!eventGroupState[projectState.selected] ||
            eventGroupState[projectState.selected].selected.length === 0 ||
            eventGroupState[projectState.selected].selected[0] ===
                eventGroupState[projectState.selected].events.length - 1}
        aria-label={m.shift_word_forward_aria_label()}
        role="button"
        onclick={shiftWordToNextEvent}
        ><strong>w</strong><sub
            ><i class="bi bi-arrow-down" aria-hidden="true"></i></sub
        ></a>
</li>
